import React, { useState, useContext, useEffect } from "react";
import { NewProjectContext } from "../context/NewProjectContext";
import { useHistory } from "react-router-dom";
import "../scss/pack-panel.scss";
import ServiceCard from "./ServiceCard";
import Loading from "./Loading";

import { getServices } from "../utils/API";

const PackPanel = () => {
  const history = useHistory();
  const { pack, handlePack, need } = useContext(NewProjectContext);

  const [loading, setLoading] = useState(true);
  const [servicessAvailable, setServicesAvailable] = useState([]);

  useEffect(() => {
    const fetchServicesAvailable = async () => {
      try {
        const res = await getServices();
        const data = res.data;
        const services = data.filter(service => {
          return need === service.categorie;
        });
        setServicesAvailable(services);
        setLoading(false);
      } catch (error) {
        console.error(
          "Un problème est survenu lors de la lecture des données !"
        );
      }
    }

    fetchServicesAvailable();
  }, [need]);

  useEffect(() => {
    if (need === "") {
      history.push("/newproject");
    }
  })

  const choosePack = () => {
    const pathname = history.location.pathname;
    if (pathname.startsWith("/prestations")) {
      history.replace(pathname, true);
    }
    else {
      history.push("/newproject/order");
    }
  }

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className="pack-panel">
          <div className="pack-container">
            {servicessAvailable.length === 0 && <h2>Aucun pack est disponible pour ce besoin !</h2>}
            {servicessAvailable.map((service, index) => (
              <ServiceCard
                id={service._id}
                key={index}
                image={service.banner}
                service={service.label}
                price={service.price}
                details={service.description}
                handler={choosePack}
                pack={pack}
                handlePack={handlePack}
              />
            ))}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PackPanel;
